module.exports = __webpack_public_path__ + "img/nybank.66b8c068.png";